const enum SponsorType {
    USER = 'user',
    ORGANISATION = 'organisation',
}

export default SponsorType